import { render, staticRenderFns } from "./choiceDevice.vue?vue&type=template&id=0f394cd8&scoped=true"
import script from "./choiceDevice.vue?vue&type=script&lang=js"
export * from "./choiceDevice.vue?vue&type=script&lang=js"
import style0 from "./choiceDevice.vue?vue&type=style&index=0&id=0f394cd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f394cd8",
  null
  
)

export default component.exports